import latinize from 'latinize';

const formatEvent = (label) => latinize(label).replace(/ /g,"_").toLowerCase()

export const getDataLayer = (data,event) => {
	if(data && data.meta && event){
		const page = data.meta.uid ? data.meta.uid : data.meta.type;
		// const event = `${data.block}${data.count != null ? `-${data.count}` : ``}${data.item != null ? `_item-${data.item}` : ``}${label != null ? `_label-${formatLabel(label)}` : ``}`;
		// const name = label;

		return {
			page,
			event:formatEvent(event)
		}
	}

	return null;
}